import { Card, Form, Button, Row, Col } from "react-bootstrap";
import Table from "../../Components/UI/Table/Table";
import FeatherIcon from "feather-icons-react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../utils/types";
import { useEffect, useState } from "react";
import {
  SetYandexData,
  GetYandexData,
} from "../../Redux/Actions/YandexActions";
import { useFormik } from "formik";
import Spinner from "../../Components/UI/Spinner/Spinner";
import CreateNewYandex from "./CreateNewYandex";
import ViewYandex from "./ViewYandex";

const Yandex = () => {
  const dispatch = useDispatch();
  const YandexState = useSelector((state: IReduxState) => state.Yandex);
  const [tableData, setTableData] = useState(YandexState?.data);
  const [filteredList,setFilteredList] = useState(YandexState?.data);
  const [isPopUp, setIsPopUp] = useState(false);
  const [isPopUpView, setIsPopUpView] = useState(false);
  const [selectedEvent,setSelectedEvent] = useState('')

  const filterEventsBySearch = (searchInput: string) => {
    if(!searchInput || searchInput.length==0){
      setFilteredList(tableData);
      return;
    }
    const filtered = filteredList.filter((event: any) => {
      return Object.values(event).some(value =>
        String(value).toLowerCase().includes(searchInput.toLowerCase())
      );
    });
  
    setFilteredList(filtered);
    //makeCSV(filtered);
  };

  const cols = [
    {
      Header: "Creative Name",
      accessor: "myDspCreativeName"
    },
    {
      Header: "Creative ID",
      accessor: "myDspCreativeId",
    },
    {
      Header: "ERID",
      accessor: "erid",
    },
    // {
    //   Header: "Inventory",
    //   accessor: "inventory",
    // },
    {
      Header: "View Tag",
      accessor: "tag",
      width: 150,
      Cell: ({ row }: any) => (
        <p style={{ display: "flex", alignItems: "center", gap:"5px" }}>
            <span 
            title="tag"
            onClick={() => {
              setSelectedEvent(row.original);
              setIsPopUpView(true)
            }}
            >
            <FeatherIcon icon="tag" className="icon-dual" />
            </span>
          </p>
      )
    }
  ];

  const sizePerPageList = [
    {
      text: "10",
      value: 10,
    },
    {
      text: "20",
      value: 20,
    },
    {
      text: "50",
      value: 50,
    },
    {
      text: "100",
      value: 100,
    },
  ];

  const formik = useFormik({
    initialValues: {
      cID: "",
      erID: "",
      search:''
    },
    onSubmit: (values, { resetForm }) => {
      const data = {
        cID: Number(values.cID),
        erID: Number(values.erID),
      };
      dispatch(
        SetYandexData(
          data
          //cID: data.cID, erID: data.erID
        )
      );
      filterEventsBySearch(formik.values.search)
      setTableData(YandexState.data);
      resetForm();
    },
  });

  useEffect(() => {
    dispatch(GetYandexData());
  }, [dispatch]);

  useEffect(() => { 
    if (YandexState?.data) {
      setTableData(YandexState.data);
      setFilteredList(YandexState.data); 
    }
  }, [YandexState.data]);

  return (
    <>
      {!isPopUp && !isPopUpView && (
      <><Row className="d-flex justify-content-center mt-3">
          <Row>
            <h3 className="module_title" style={{ marginBottom: "0px" }}>
              Yandex
            </h3>
          </Row>
        </Row><Card>
            <Card.Body>
              <Row style={{ marginTop: "10px" }}>
                <div className="tableActions">
                  <Col>
                    <Form.Label
                      // style={{width:'55px'}}
                      // htmlFor="simpleinput"
                      id="smallerFontSize"
                      className="noMargin"
                    >
                    </Form.Label>
                    <Form.Control
                      style={{ borderRadius: "0.375rem", width: '473px', marginLeft: '1px' }}
                      id="search"
                      type="text"
                      name="search"
                      placeholder="Search"
                      className="fsz-875rem"
                      value={formik.values.search}
                      onChange={formik.handleChange}
                      isInvalid={!!formik.errors?.search} />
                    <div>
                      <Button
                        className="noMargin"
                        style={{ backgroundColor: '#25c2e3', borderColor: '#25c2e3', color: '#fff' }}
                        onClick={() => {
                          formik.handleSubmit();
                        } }
                        variant="primary"
                      >
                        Search
                      </Button>
                    </div>
                  </Col>
                  <Col
                    lg={6}
                    style={{ display: "flex", justifyContent: "end" }}
                    className="order-12"
                  >
                    <Button
                      onClick={() => setIsPopUp(true)}
                      variant="primary"
                      style={{ margin: "0" }}
                    >
                      + Add Creative
                    </Button>
                  </Col>
                </div>
              </Row>
              {YandexState.loading && (
                <div className="popUpUser">
                  <Spinner className="m-2" color={"primary"}></Spinner>
                </div>
              )}
              <Table
                columns={cols}
                data={filteredList}
                pageSize={10}
                sizePerPageList={sizePerPageList}
                isSortable={false}
                pagination={true}
                isSearchable={false} />
            </Card.Body>
          </Card></>
    )}
      {isPopUp && (
        <CreateNewYandex
          dispatch={dispatch}
          setIsPopUp={setIsPopUp}
        />
      )}
      {isPopUpView && (
        <ViewYandex
        // dispatch={dispatch}
        setIsPopUpView ={setIsPopUpView}
        eventData={selectedEvent}
        />
      )}
    </>
  );
};

export default Yandex;
